import React from "react"
import { GrFacebookOption } from "react-icons/gr"
import { FaLinkedinIn } from "react-icons/fa"
import { AiOutlineInstagram } from "react-icons/ai"
import { FiTwitter } from "react-icons/fi"
import { IconType } from "react-icons"
import clsx from "clsx"

interface SocialMediaLinkProps {
  url: string
  Icon: IconType
  label: string
}

const SocialMediaLink = ({ Icon, url, label }: SocialMediaLinkProps) => {
  return (
    <div>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        className={clsx(
          "sm:border-2 border rounded-full p-1 flex justify-center items-center sm-only:text-xs border-grey-ec",
          "sm:wh-8 wh-5"
        )}
      >
        <Icon />
      </a>
    </div>
  )
}

function Socmed() {
  const SOCIAL_LINKS: SocialMediaLinkProps[] = [
    {
      Icon: FaLinkedinIn,
      label: "LinkedIn",
      url: "https://www.linkedin.com/company/harisenin-com/",
    },
    {
      Icon: GrFacebookOption,
      label: "Facebook",
      url: "https://web.facebook.com/harisenincom",
    },
    {
      Icon: AiOutlineInstagram,
      label: "Instagram",
      // url: "https://www.instagram.com/harisenincom/",
      url: "https://www.instagram.com/harisenin.official/",
    },
    {
      Icon: FiTwitter,
      label: "Twitter",
      url: "https://twitter.com/harisenincom",
    },
  ]

  return (
    <div className="flex sm:gap-4 gap-2 w-shrink my-auto">
      {SOCIAL_LINKS.map((sm, i) => (
        <SocialMediaLink {...sm} key={i} />
      ))}
    </div>
  )
}

export default Socmed
